import { combineReducers } from 'redux';
import Map from './Map';

const reducers = combineReducers({
    map:Map
});

export default reducers;